import { Link } from "react-router-dom";
import { ArrowUpRight, Instagram, Linkedin, Mail, MapPin } from "lucide-react";
import Logo from "../assets/logo/logo.svg";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#002b3b] text-white">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-14 sm:px-6 lg:grid-cols-[1.2fr_0.8fr_0.8fr_1fr] lg:px-8">
        <div>
          <img src={Logo} alt="Lightning Technologies" className="h-12 w-auto brightness-0 invert" />
          <p className="mt-5 max-w-sm text-sm leading-6 text-slate-300">
            Software built to simplify operational work, surface better insights and help businesses grow with less manual effort.
          </p>
          <div className="mt-6 flex items-center gap-3 text-sm text-slate-300">
            <MapPin className="h-4 w-4 text-[#7ddcff]" /> Pune, Maharashtra, India
          </div>
        </div>

        <div>
          <p className="footer-heading">Product</p>
          <div className="mt-4 flex flex-col space-y-3 text-sm text-slate-300">
            <a href="/#product" className="footer-link">MarketMind ERP</a>
            <a href="/#dashboards" className="footer-link">Dashboards</a>
            <a href="/#automation" className="footer-link">Automation</a>
            <a href="/#whatsapp" className="footer-link">WhatsApp Automation</a>
            <a href="/#analytics" className="footer-link">Analytics</a>
          </div>
        </div>

        <div>
          <p className="footer-heading">Company</p>
          <div className="mt-4 flex flex-col space-y-3 text-sm text-slate-300">
            <Link to="/pricing" className="footer-link">Pricing</Link>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <Link to="/terms-conditions" className="footer-link">Terms & Conditions</Link>
          </div>
        </div>

        <div>
          <p className="footer-heading">Get in touch</p>
          <div className="mt-4 space-y-3 text-sm text-slate-300">
            <a href="tel:+919370551806" className="flex items-center gap-2 footer-link"><Mail className="h-4 w-4" /> +91-9370551806</a>
            <a href="mailto:sales@lightningtechnologies.net" className="flex items-center gap-2 footer-link"><Mail className="h-4 w-4" /> sales@lightningtechnologies.net</a>
            <a href="mailto:care@lightningtechnologies.net" className="flex items-center gap-2 footer-link"><Mail className="h-4 w-4" /> care@lightningtechnologies.net</a>
            <div className="flex gap-3 pt-2">
              <a href="https://www.linkedin.com/company/lightning-tech" target="_blank" rel="noreferrer" className="social-btn"><Linkedin className="h-4 w-4" /></a>
              <a href="https://www.instagram.com/lightningtechnologiespune/" target="_blank" rel="noreferrer" className="social-btn"><Instagram className="h-4 w-4" /></a>
              <a href="/pricing" className="social-btn"><ArrowUpRight className="h-4 w-4" /></a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-white/10 px-4 py-5 text-center text-xs text-slate-400">
        © 2026 Lightning Technologies. All rights reserved.
      </div>
    </footer>
  );
}
